const initialState = {
    FBRCompanyList: [],
    FBRCompanyDataList: [],
    isFetchingFBRCompany: false,
    isAddingFBRCompany: false,
};

const FBRCompanyReducer = (state = initialState, action) => {
    switch (action.type) {

        case "REQUEST_ADD_FBR_COMPANY":
            return { ...state, isAddingFBRCompany: true };
        case "SUCCESS_ADD_FBR_COMPANY":
            return { ...state, FBRCompanyList: action.payload, isAddingFBRCompany: false, };
        case "ERROR_ADD_FBR_COMPANY":
            return { ...state, isAddingFBRCompany: false };


        case "REQUEST_GET_FBR_COMPANY":
            return { ...state, isFetchingFBRCompany: true };
        case "SUCCESS_GET_FBR_COMPANY":
            return { ...state, FBRCompanyDataList: action.payload.data, isFetchingFBRCompany: false, };
        case "ERROR_GET_FBR_COMPANY":
            return { ...state, };


        default:
            return state;
    }
};
export default FBRCompanyReducer;